<template>
  <footer class="pb-30">
    <div class="w-full bg-black blex">
      <div
          class="w-full lg:w-7/10 bg-black blex-between flex-no-wrap px-16 lg:px-0 pb-30 lg:pb-80 bottom-gradient pt-30 lg:pt-100">

        <!-- copyright     -->
        <div>
          <logo/>

          <!-- navigation / mobile    -->
          <div class="blex items-start w-full flex-no-wrap lg:hidden flex">

            <div class="blex">
              <div @click="goScroll('trailer')" class="cursor-pointer w-full text-white text-3xs font-normal pb-16">
                TRAILER
              </div>
              <div @click="goScroll('token')" class="cursor-pointer w-full text-white text-3xs font-normal pb-16">
                TOKEN
              </div>
              <div @click="goScroll('pte')" class="cursor-pointer w-full text-white text-3xs font-normal pb-16">
                PLAY TO EARN
              </div>
              <div @click="goScroll('cte')" class="cursor-pointer w-full text-white text-3xs font-normal pb-16">
                CLEAN TO EARN
              </div>
              <div @click="goScroll('ugc')" class="cursor-pointer w-full text-white text-3xs font-normal pb-16">
                UGC
              </div>
              <div @click="goScroll('seed-box')" class="cursor-pointer w-full text-white text-3xs font-normal pb-16">
                SEEDBOX
              </div>
              <div @click="goScroll('voice-video')" class="cursor-pointer w-full text-white text-3xs font-normal pb-16">
                VOICE & VIDEO CHAT
              </div>
              <div @click="goScroll('dao')" class="w-full text-white text-3xs font-normal pb-16">
                DAO
              </div>
            </div>

            <div class="blex">
              <div @click="goScroll('the-map')" class="w-full text-white text-3xs font-normal pb-16">
                MAP
              </div>
              <div @click="goScroll('nft')" class="w-full text-white text-3xs font-normal pb-16">
                NFT COLLECTION
              </div>
              <div @click="goScroll('pfp')" class="w-full text-white text-3xs font-normal pb-16">
                PFP
              </div>
              <div @click="goScroll('nft-market')" class="w-full text-white text-3xs font-normal pb-16">
                NFT MINTING PAGE
              </div>
              <div @click="goScroll('road-map')" class="w-full text-white text-3xs font-normal pb-16">
                ROADMAP
              </div>
              <!--              <div @click="goScroll('team')" class="w-full text-white text-3xs font-normal pb-16">-->
              <!--                TEAM-->
              <!--              </div>-->
              <div @click="goScroll('partner')" class="w-full text-white text-3xs font-normal pb-16">
                PARTNERS
              </div>
              <div @click="goScroll('listed')" class="w-full text-white text-3xs font-normal pb-16">
                LISTED
              </div>
            </div>

          </div>

          <div class="text-gray text-3xs lg:text-normal font-normal pt-40 lg:pt-180">
            MetaRising is a verified UN Global Vendor. (UN Vendor #521011)
          </div>
          <!--          <div class="text-gray text-3xs lg:text-normal font-normal py-8">-->
          <!--            -->
          <!--          </div>-->
          <div class="text-gray text-3xs lg:text-normal font-normal">
            Copyright © 2022 <a class="text-gray" target="_blank"
                                href="https://microtuber.io">Microtuber</a>. All Rights Reserved.
          </div>
        </div>

        <!-- navigation /lg    -->
        <div class="blex items-start w-1/3 flex-no-wrap hidden lg:flex">

          <div class="blex">
            <div @click="goScroll('trailer')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              TRAILER
            </div>
            <div @click="goScroll('token')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              TOKEN
            </div>
            <div @click="goScroll('pte')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              PLAY TO EARN
            </div>
            <div @click="goScroll('cte')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              CLEAN TO EARN
            </div>
            <div @click="goScroll('ugc')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              UGC
            </div>
            <div @click="goScroll('seed-box')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              SEEDBOX
            </div>
            <div @click="goScroll('voice-video')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              VOICE & VIDEO CHAT
            </div>
            <div @click="goScroll('dao')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              DAO
            </div>
          </div>

          <div class="blex">
            <div @click="goScroll('the-map')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              MAP
            </div>
            <div @click="goScroll('nft')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              NFT COLLECTION
            </div>
            <div @click="goScroll('pfp')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              PFP
            </div>
            <div @click="goScroll('nft-market')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              NFT MINTING PAGE
            </div>
            <div @click="goScroll('road-map')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              ROADMAP
            </div>
            <!--            <div @click="goScroll('team')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">-->
            <!--              TEAM-->
            <!--            </div>-->
            <div @click="goScroll('partner')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              PARTNERS
            </div>
            <div @click="goScroll('listed')" class="cursor-pointer w-full text-white text-lg font-normal pb-24">
              LISTED
            </div>
          </div>

        </div>

      </div>

      <!--contact us    -->
      <div class="bg-black w-full lg:w-7/10 blex-between flex-wrap lg:flex-no-wrap px-16 lg:px-0 py-30">

        <div class="text-white font-normal text-3xs lg:text-lg">
          CONTACT US
          <a href="mailto:info@microtuber.io" class="text-white pl-12">
            info@microtuber.io
          </a>
        </div>

        <div class="py-12 lg:py-0">
          <div class="blex flex-no-wrap">
            <div
                class="text-white font-normal text-3xs lg:text-lg pr-8 lg:pr-16 whitespace-no-wrap w-3/5 lg:w-auto">
              KOREA CHANNEL
            </div>
            <div class="blex flex-no-wrap lg:flex-wrap w-full lg:w-auto">
              <a href="https://www.facebook.com/playmetarisingkorea/" target="_blank" class="icon">
                <img src="@/assets/images/icon/facebook.svg" class="blex">
              </a>
              <a href="https://www.instagram.com/metarisingkorea/" target="_blank" class="icon">
                <img src="@/assets/images/icon/insta.svg" class="blex">
              </a>
              <a href="https://twitter.com/Metarisingkorea" target="_blank" class="icon">
                <img src="@/assets/images/icon/twitter.svg" class="blex">
              </a>
              <a href="https://medium.com/@playmetarisingkorea" target="_blank" class="icon">
                <img src="@/assets/images/icon/medium.svg" class="blex">
              </a>
              <a href="https://t.me/microtuber" target="_blank" class="icon">
                <img src="@/assets/images/icon/flight.svg" class="blex">
              </a>
              <a href="https://blog.naver.com/microtuber" target="_blank" class="icon">
                <img src="@/assets/images/icon/blog.svg" class="blex">
              </a>
            </div>
          </div>
        </div>

        <div>
          <div class="blex flex-no-wrap">
            <div
                class="text-white font-normal text-3xs lg:text-lg pr-8 lg:pr-16 whitespace-no-wrap w-3/5 lg:w-auto">
              GLOBAL CHANNEL
            </div>
            <div class="blex flex-no-wrap lg:flex-wrap w-full lg:w-auto">
              <a href="https://www.facebook.com/MicroTuber" target="_blank" class="icon">
                <img src="@/assets/images/icon/facebook.svg" class="blex">
              </a>
              <a href="https://www.Instagram.com/playmetarising" target="_blank" class="icon">
                <img src="@/assets/images/icon/insta.svg" class="blex">
              </a>
              <a href="https://Twitter.com/playmetarising" target="_blank" class="icon">
                <img src="@/assets/images/icon/twitter.svg" class="blex">
              </a>
              <a href="https://medium.com/@playmetarising_47240" target="_blank" class="icon">
                <img src="@/assets/images/icon/medium.svg" class="blex">
              </a>
              <a href="https://t.me/metarising" target="_blank" class="icon">
                <img src="@/assets/images/icon/flight.svg" class="blex">
              </a>
              <a href="https://discord.gg/metarising" target="_blank" class="icon">
                <img src="@/assets/images/icon/discord.svg" class="blex">
              </a>
              <a href="https://www.youtube.com/channel/UCBxY92VhkRwG96SvEIZEYwg" target="_blank icon"
                 class="">
                <img src="@/assets/images/icon/youtube.svg" class="blex">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

import Logo from '@/components/logo/Logo'
import {EventBus} from '../../EventBus'

export default {
  name: 'the-footer',
  components: {
    Logo
  },
  methods: {
    goScroll (className) {
      EventBus.$emit('scrollTo', document.getElementsByClassName(className)[0])
    }
  },
  mounted () {
    // if (this.$scrollTrigger) {
    //   this.$scrollTrigger.refresh()
    // }
  }
}
</script>

<style scoped lang="scss">
footer::v-deep {
  .logo {
    width: 340px;
    height: 60px;
    @media screen and(max-width: 1024px) {
      width: 156px;
      margin-bottom: 40px;
    }
  }

  .icon {
    margin-right: 8px;
    @media screen and(max-width: 1024px) {
      width: 15px;
      margin-right: 16px;
      &:hover {
        cursor: pointer;
      }
    }

  }
}

</style>
